"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_i18next_1 = require("react-i18next");
var InMeetingAlert = /** @class */ (function (_super) {
    __extends(InMeetingAlert, _super);
    function InMeetingAlert(props) {
        var _this = _super.call(this, props) || this;
        _this.localize = _this.props.t;
        return _this;
    }
    InMeetingAlert.prototype.render = function () {
        return (React.createElement("div", { className: "taskModule" },
            React.createElement("div", { className: "formContainer", style: { height: "100%" } },
                React.createElement(react_northstar_1.Flex, { vAlign: "center", hAlign: "center", gap: "gap.medium", styles: { padding: "0 3rem", textAlign: "center" }, column: true },
                    React.createElement(react_northstar_1.Image, { src: "/images/expired.svg" }),
                    React.createElement(react_northstar_1.Text, { size: "medium", content: this.localize("AlertaAtendimentoExpirado") })))));
    };
    return InMeetingAlert;
}(React.Component));
var inMeetingAlertWithTranslation = react_i18next_1.withTranslation()(InMeetingAlert);
exports.default = inMeetingAlertWithTranslation;
//# sourceMappingURL=in-meeting-alert.js.map